import React, { Component } from 'react'
import * as firebase from "firebase/app";
import "firebase/auth";
import { withRouter } from 'react-router-dom'
import Header from '../../components/Header';

class Signup extends Component {
  state = {
    username: '',
    password: '',
    loading: false,
  }

  updateInput = (evt) => {
    this.setState({
      ...this.state,
      [evt.target.name]: evt.target.value
    })
  }
  signup = (e) => {
    e.preventDefault();

    this.setState({
      ...this.state,
      loading: true
    })

    const { username, password } = this.state;

    firebase.auth().createUserWithEmailAndPassword(username, password).then(() => {
      this.setState({
        ...this.state,
        loading: false
      });
      this.props.history.push('/login')
    }).catch(function (error) {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log(`Error ${errorCode}: ${errorMessage}`);
    });
  }
  render() {
    return (
      <div>
        <Header />
        <form onSubmit={this.signup}>
          <h1>Create Account</h1>
          <input type="email" name="username" placeholder="Email" value={this.state.username} onChange={this.updateInput} autoComplete="email" />
          <input type="password" name="password" placeholder="Your Secret" value={this.state.password} onChange={this.updateInput} autoComplete="new-password" />
          <button type="submit">Sign Up</button>
        </form>
      </div>
    )
  }
}

export default withRouter(Signup);
